import { render } from "./vipEquity.vue?vue&type=template&id=caca8146&scoped=true"
import script from "./vipEquity.vue?vue&type=script&lang=js"
export * from "./vipEquity.vue?vue&type=script&lang=js"

import "./vipEquity.vue?vue&type=style&index=0&id=caca8146&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caca8146"]])

export default __exports__